import axios from "axios";

// Local FastAPI backend (notifications, apk uploader). REACT_APP_BACKEND_URL is
// the SAME-ORIGIN preview/deploy URL — it proxies /api/* to our local server.
const LOCAL = process.env.REACT_APP_BACKEND_URL;
export const LOCAL_API = `${LOCAL || ""}/api`;
const localApi = axios.create({ baseURL: LOCAL_API, timeout: 15000 });

// Attach the external-API bearer token so /notifications endpoints can verify identity.
localApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("nd_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default localApi;
